// Import all images
import image1 from "../images/codershub_slide.png";

import image2 from "../images/dreilinden_slide.png";
import image3 from "../images/bdtronic_slide.png";
import image4 from "../images/dcs.svg";
import image5 from "../images/coop_slide.png";
import image6 from "../images/kw3-2slider.png";

// Export the array of images with URLs
export const images = [
  { src: image1, url: "https://codershubeu.com/" },
  { src: image2, url: "https://www.dreilindenag.ch/" },
  { src: image3, url: "https://www.bdtronic.com/en-en/" },
  { src: image4, url: "http://dcs-tec.de/" },
  {
    src: image5,
    url: "https://www.coop.ch/en/?srsltid=AfmBOoo4FCV7ugKLBq4mOft86zQcOLk58XtUyPJmDfcoIM0llSn58ZXP",
  },
  { src: image6, url: "https://k-we.com/" },
];
